import { render, staticRenderFns } from "./quickProceDialog.vue?vue&type=template&id=979b21b6&scoped=true"
import script from "./quickProceDialog.vue?vue&type=script&lang=js"
export * from "./quickProceDialog.vue?vue&type=script&lang=js"
import style0 from "./quickProceDialog.vue?vue&type=style&index=0&id=979b21b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979b21b6",
  null
  
)

export default component.exports